// extracted by mini-css-extract-plugin
export default {"link":"download_link-module___link___e34a66c0","link2":"download_link-module___link2___f8cd4e4e"};